export const formatPhoneNumber = (phoneNum: string | number | null | undefined): string => {
    if (!phoneNum) {
        return ''
    }

    const digitsOnly = `${phoneNum}`.replace(/\D+/g, '')
    const digitsOnlyWithoutLeadingOne = digitsOnly.replace(/^1/, '')

    if (digitsOnlyWithoutLeadingOne.length < 10) {
        return digitsOnly
    }

    const first = digitsOnlyWithoutLeadingOne.slice(0, 3)
    const second = digitsOnlyWithoutLeadingOne.slice(3, 6)
    const last = digitsOnlyWithoutLeadingOne.slice(6, 10)

    return `(${first}) ${second}-${last}`
}
